import {getLocalStorageValue} from 'config/helper'
import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'

import {getStoreList} from 'redux/actions'
import {useApiDefaults} from './useApiDefaults'

export default function useStoreList() {
  const {storeListData} = useSelector(({store}) => store)
  const dispatch = useDispatch()

  const apiDefaults = useApiDefaults()

  const clientId = getLocalStorageValue('RSAclient-id')

  const aogEndPointURL = getLocalStorageValue('api-end-point-aog')

  useEffect(() => {
    if (clientId && aogEndPointURL) {
      dispatch(getStoreList(apiDefaults))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, aogEndPointURL])

  return {storeListData}
}
